module.exports = __webpack_public_path__ + "static/media/SDLogger.0000cfbc.png";